export const convertDataToForm = (data: any) => ({
  name: data.name,
});
